<template>
  <el-dialog
    class="rc-dialog"
    :title="title"
    :visible.sync="dialogInfo.show"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="850px"
  >
    <div class="dialog-content" v-loading="loadStatus === 1">
      <div class="empty" v-if="loadStatus === 3">
        暂无自习室相关信息
      </div>
      <el-form
        v-else
        ref="roomForm"
        size="small"
        label-position="right"
        label-width="140px"
        :model="roomForm"
        :rules="rules"
        :disabled="disable"
      >
        <el-col :span="24">
          <el-form-item label="自习室组名称：" prop="roomGroupName">
            <el-input
              v-model="roomForm.roomGroupName"
              placeholder="请输入自习室组名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="自习室组列表：">
            <div
              class="room-content"
              v-if="
                roomForm.roomGroupInfoDtos &&
                  roomForm.roomGroupInfoDtos.length > 0
              "
            >
              <div
                class="room-item"
                v-for="(item, index) in roomForm.roomGroupInfoDtos"
                :key="index"
              >
                <div class="room-item__name">{{ item.groupName }}</div>
                <div class="room-item__select">
                  <load-select
                    class="form-select"
                    v-model="item.roomId"
                    dictLabel="teachingLocation"
                    dictValue="uuid"
                    :data="data"
                    :page="page"
                    :hasMore="more"
                    :request="getData"
                    @change="setChange"
                    :defaultVal="item.teachingLocation"
                    :placeholder="(disable &&
                        item.teachingLocation &&
                        item.teachingLocation.length > 0) ||
                      !disable
                        ? '请选择地点（输入地点关键字以查询）'
                        : '--'"
                    :isInit="isSetInit"
                    :isAllowCreate="true"
                    @ChangeValue="changeValue($event, item)"
                  />
                </div>
              </div>
            </div>
            <div v-else-if="loadStatus != 1">
              暂无分组数据，请先在【分组管理】设置分组。
            </div>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer" v-if="dialogInfo.type != 2 ">
      <butn @click="closeDialog" title="取消"></butn>
      <butn v-if="loadStatus != 3 " btntype="primary" @click="createData" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import { classRoomPage } from "@/api/class";
import { classRoomGroupInfo, classRoomGroupSave } from "@/api/classOffline";
import butn from "@/components/button/index";
import LoadSelect from "@/components/load-select/index.vue";

export default {
  components: { butn, LoadSelect },
  data() {
    return {
      more: true,
      page: 1,
      data: [],
      isSetInit: true,
      title: "自习室组详情",
      disable: false,
      roomForm: {
        roomGroupName: "",
        roomGroupInfoDtos: [],
      },
      rules: {
        roomGroupName: [{ required: true, message: "请输入自习室组名称" }],
      },
      loadStatus: 1,
      titles: ["新增自习室组", "编辑自习室组", "自习室组详情"],
    };
  },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
          uuid: "",
          type: 0, // 关联titles数组
        };
      },
    },
    classId: {
      type: String,
      default: () => "",
    },
  },
  created() {
    this.title = this.titles[this.dialogInfo.type || 0];
    this.disable = this.dialogInfo.type == 2;
    this.getInfo();
  },
  methods: {
    /**
     * 获取自习室详情信息
     */
    getInfo() {
      this.loadStatus = 1;
      classRoomGroupInfo({ classId: this.classId, uuid: this.dialogInfo.uuid })
        .then(({ code, data }) => {
          if (code !== 0) {
            this.loadStatus = 3;
            return;
          }
          this.loadStatus = 2;
          if (data && Object.keys(data).length > 0) {
            this.roomForm = {
              roomGroupName: data.roomGroupName || "",
              roomGroupInfoDtos: JSON.parse(
                JSON.stringify(data.roomGroupInfoDtos || [])
              ),
            };
          }
        })
        .catch((err) => {
          this.loadStatus = 3;
        });
    },

    // 点击确定--新增自习室组
    createData() {
      this.$refs["roomForm"].validate().then(() => {
        let params = { ...this.roomForm, classId: this.classId };
        let flag = false;
        for (let i = 0; i < params.roomGroupInfoDtos.length; i++) {
          let item = params.roomGroupInfoDtos[i];
          if (!item.teachingLocation || item.teachingLocation.length == 0) {
            flag = true;
            break;
          }
        }
        if (this.dialogInfo.uuid && this.dialogInfo.uuid.length > 0) {
          params.uuid = this.dialogInfo.uuid;
        }
        if (flag) {
          this.$confirm("还有小组未设置自习室，确定提交吗？", "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.save(params);
          });
        } else {
          this.save(params);
        }
      });
    },

    save(params) {
      // 新增/编辑
      classRoomGroupSave(params, this.dialogInfo.type == 1).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.$parent.delQuery();
        this.$emit("close");
      });
    },

    // 下拉加载地点
    getData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        classRoomPage({ page, teachingLocation: keyword }).then(
          ({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.data = [...this.data, ...data.records];
            } else {
              this.data = data.records;
            }
            this.page = data.current;
            let { current, total, size } = data;
            this.more = current * size < total;
            this.page = current;
            resolve();
          }
        );
      });
    },
    // 下拉加载
    setChange() {
      // this.isSetInit = false;
    },
    changeValue(value, item) {
      let val = value.replace(/(^\s*)|(\s*$)/g, "");
      if (!!val) {
        let room = this.data.filter((item) => item.uuid == val)[0];
        if (!room) {
          item.teachingLocation = val;
          item.roomId = "";
        } else {
          item.teachingLocation = room.teachingLocation;
        }
      } else {
        item.teachingLocation = "";
        item.roomId = "";
      }
    },

    closeDialog() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    max-height: 400px;
  }
}

.room-content {
  background-color: #f6f7f8;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 20px 8px;

  max-height: 340px;
  overflow-y: scroll;
  .room-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 12px;
    &__name {
      width: 140px;
      margin-right: 20px;
      text-align: right;
    }
    &__select {
      // width: 100% !important;
      flex: 1;
    }
  }
}
.form-select {
  width: 400px !important;
}

.empty {
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
